import React from 'react';
import { AssetAllocation } from '../../../../CommonUtils/getAssetColors';
import { formatPercentage } from '../../../../CommonUtils/formatNumber';
import { StackedBar } from '../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Dot } from '../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';

interface Props extends WrapperProps {
  assetAllocation: AssetAllocation[];
}

export const StackedBarChart: React.FC<Props> = ({ assetAllocation }) => {
  const stackedData = assetAllocation.map(({ name, y, ...assetData }) => ({
    label: name,
    value: y,
    ...assetData,
  }));

  return (
    <Box mt="32" mb="auto">
      <StackedBar data={stackedData} formatter={formatPercentage} />

      <Box
        borderBottom="1px solid"
        borderColor="neutral.200"
        display="flex"
        justifyContent="space-between"
        pt="24"
        pb="12"
      >
        <Text variant="smallCaps" fontWeight={500} color="neutral.700">
          Asset Category
        </Text>
        <Text variant="smallCaps" fontWeight={500} color="neutral.700">
          Allocation
        </Text>
      </Box>

      <Box as="ol" css="list-style-type: none" p="0">
        {assetAllocation.map(({ name, y, color }) => (
          <Box
            alignItems="center"
            as="li"
            borderBottom="1px solid"
            borderColor="neutral.200"
            display="flex"
            justifyContent="space-between"
            key={name}
            py="12"
            width="100%"
          >
            <Box display="flex" alignItems="center">
              <Dot bg={color} mr="12" />
              <Text fontWeight={500} color="neutral.700">
                {name}
              </Text>
            </Box>
            <Text variant="tabular" fontWeight={500} color="neutral.700">
              {formatPercentage(y)}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
